/**
 * MB-AI-SUPPORT-2C — Allowlist des routes marketing où le widget flottant de
 * l'assistant support s'affiche.
 *
 * Liste BLANCHE uniquement : toute route non listée ci-dessous est exclue par
 * défaut (y compris une future page marketing ajoutée à App.js sans mise à
 * jour de ce fichier — fail-safe côté visibilité, pas fail-open).
 *
 * Volontairement exclues (jamais dans cette liste) : /terms, /privacy,
 * /legal, /cgv-materiel, /paiement-virement, /login, /platform/login,
 * /register, /verify-email, /invitation/:token — pages légales/techniques où
 * l'assistant n'apporte pas d'aide pertinente. Toutes les routes `/app/*`
 * (OS/POS/App Client) sont hors périmètre de cette allowlist : elles
 * utilisent le mode `embedded` du widget, jamais le bouton flottant.
 *
 * Routes construites à partir de `frontend/src/App.js` (aucune route
 * inventée) — voir AUDIT_MB-AI-SUPPORT-2.md, partie MB-AI-SUPPORT-2C, §C.
 */

const EXACT_ROUTES = [
  '/', '/en',
  '/solutions', '/en/solutions',
  '/formules', '/en/pricing',
  '/pourquoi-superkawa',
  '/app-preview', '/en/features',
  '/blog', '/en/blog',
  '/logiciel-caisse-restaurant',
  '/logiciel-restaurant',
  '/logiciel-coffee-shop',
  '/programme-fidelite-restaurant',
  '/crm-restaurant',
  '/paiement-qr-code-restaurant',
  '/en/restaurant-pos-software',
  '/en/cafe-pos-software',
  '/en/restaurant-management-software',
  '/en/restaurant-software',
  '/en/restaurant-loyalty-program',
  '/en/restaurant-qr-payments',
  '/en/restaurant-digital-menu',
];

const PREFIX_ROUTES = [
  '/blog/',
  '/en/blog/',
  '/comparatif/',
  '/en/comparison/',
];

/** Normalise un pathname (retire query string et hash) avant comparaison. */
function normalizePathname(pathname) {
  if (typeof pathname !== 'string' || !pathname) return '';
  return pathname.split('?')[0].split('#')[0];
}

export function isSupportWidgetRoute(pathname) {
  const path = normalizePathname(pathname);
  if (!path) return false;
  if (EXACT_ROUTES.includes(path)) return true;
  return PREFIX_ROUTES.some((prefix) => path.startsWith(prefix));
}

export const SUPPORT_WIDGET_EXACT_ROUTES = EXACT_ROUTES;
export const SUPPORT_WIDGET_PREFIX_ROUTES = PREFIX_ROUTES;
